import { useEffect, useState } from 'react'
import { dropPopMotion } from '@/src/renderer/lib/motion/dropPopMotion'

/** So lange gleitet und poppt Abgelegtes (`dropPopMotion`) — Aufgaben wie Abschnitte. */
export const DROP_LANDING_MS = dropPopMotion({ dx: 0, dy: 0 }).duration

/**
 * Ruht die Auswahl-Hülle? Während eines Zugs und danach, bis das Abgelegte gelandet ist: Es gleitet
 * per `transform` an seinen Platz und poppt mit Schatten — den Weg sieht die Hülle nicht, sie stünde
 * schon am Ziel. Solange malen die Zeilen ihre Markierung selbst (#293, Diff-Audit).
 *
 * Im Rendern abgeleitet: Ein Bild ohne Markierung zwischen Loslassen und Effekt wäre zu sehen.
 *
 * @example
 * const resting = useRestAfterDrop(!!activeDragId)
 * <SelectionHull suspended={resting} … />
 */
export function useRestAfterDrop(active: boolean): boolean {
  const [landing, setLanding] = useState(false)
  const [wasActive, setWasActive] = useState(active)
  if (wasActive !== active) {
    setWasActive(active)
    setLanding(wasActive && !active)
  }
  useEffect(() => {
    if (!landing) return
    const timer = setTimeout(() => setLanding(false), DROP_LANDING_MS)
    return () => clearTimeout(timer)
  }, [landing])
  return active || landing
}
